import * as THREE from "three";
import Constants from "../Constants.js"
import AssetLoadingManager from './AssetLoadingManager/AssetLoadingManager.js'
import AutoPlacementManager from './AutoPlacement/AutoPlacementManager.js'
import {Space} from '../../Space.js'
import CONSTANTS from '../../environments'
export default class SceneLoader {
    previousAssetsLoaded = 0;
    previousTotalAssets = 0;

    managersDict = null;
    spaceURL = null;
    assetManager = null;
    space = null;
    sceneCreator = null;
    spaceConfigurator = null;
    baseDirURL = CONSTANTS.ASSET_GLB_URL;
    sceneType = null;
    debugEngine = null;
    lostAndFoundAreaItems = [];
    sceneAssets = [];
    spaceItemsList = {};
    editModeOn = true;
    itemCategoryList = {};
    relationshipsList = {};
    raycastManager = null;
    scene = null;
    sceneToLoadInfo = null;
    sceneToLoadAssets = null;
    spaceConfigurationInfo = null;
    /**
     * Scene Loader Manager allows you to manage loading of space, assets and their auto placement in the scene.
     * @param {SceneCreator} sceneCreator - The main scene creator instance.
     * @param {THREE.Scene} scene - The main Three JS scene that contains all of the objects.
     * @param {URL} spaceURL - The url to download the space glb from.
     * @param {String} sceneType - The scene type to identify and differentiate the customer scenes from admin test scenes.
     * @param {Object} spaceItemsList - The collections of assets
     * @param {Object} - The scene loading info json that contains assets and camera information
     * @param {Object} managersDict - A dictionary that contains all the available managers.
     */
    constructor(sceneCreator, scene, spaceObj, sceneType, spaceItemsList, itemCategoryList, itemsPlacementList, itemMaterialTypes, sceneToLoadInfo, managersDict, setLoadingProgressMessage) {

        this.sceneCreator = sceneCreator;
        this.scene = scene;
        this.managersDict = managersDict;
        this.spaceObj = spaceObj;
        this.sceneType = sceneType;
        this.spaceItemsList = spaceItemsList;
        this.itemCategoryList = itemCategoryList;
        this.itemsPlacementList = itemsPlacementList;
        this.itemMaterialTypes = itemMaterialTypes;
        this.sceneToLoadInfo = sceneToLoadInfo;
        if (this.sceneToLoadInfo != null) {
            this.sceneToLoadAssets = this.sceneToLoadInfo.assets;
            this.spaceConfigurationInfo = this.sceneToLoadInfo.space_configuration
        }
        this.setLoadingProgressMessage = setLoadingProgressMessage;
        this.setupPreSpaceManagers();
        this.parseRelationshipData();
    }

    /**
     * parse connection between assets and their categories
     */
    parseRelationshipData( ) {
        let assetCategoryInfo = '{"assets":[{"id":405,"category":"Chair"},{"id":406,"category":"Chair"},{"id":409,"category":"Beds"},{"id":410,"category":"Chair"},{"id":447,"category":"Mirrors"},{"id":468,"category":"Lamps/Lighting"},{"id":470,"category":"Lamps/Lighting"},{"id":471,"category":"Side Table"},{"id":473,"category":"Side Table"},{"id":474,"category":"Lamps/Lighting"},{"id":475,"category":"Window Panels"},{"id":477,"category":"Curtain Rods"},{"id":479,"category":"Console Table"},{"id":480,"category":"Lamps/Lighting"},{"id":483,"category":"Glasses"},{"id":484,"category":"Decorative Accessories"},{"id":629,"category":"Sofas"},{"id":639,"category":"Vases"},{"id":640,"category":"Sofas"},{"id":641,"category":"Throw Pillows"},{"id":642,"category":"Throw Pillows"},{"id":643,"category":"Throw Pillows"},{"id":645,"category":"Side Table"},{"id":646,"category":"Floor Lamps"},{"id":647,"category":"Coffee Tables"},{"id":648,"category":"Accent Chairs"},{"id":649,"category":"Media Cabinets"},{"id":650,"category":"Wall Sconces"},{"id":655,"category":"Vases"},{"id":656,"category":"Vases"},{"id":657,"category":"Decorative Accessories"},{"id":658,"category":"Decorative Accessories"},{"id":659,"category":"Area Rugs"},{"id":660,"category":"Wall Mirrors"},{"id":663,"category":"Area Rugs"},{"id":664,"category":"Dining Tables"},{"id":666,"category":"Dining Chair"},{"id":667,"category":"Chandeliers"},{"id":668,"category":"Wall Art"},{"id":669,"category":"Decorative Accessories"},{"id":671,"category":"Decorative Accessories"},{"id":672,"category":"Decorative Accessories"},{"id":673,"category":"Pendant Lamps"},{"id":674,"category":"Stools"},{"id":675,"category":"Bowls"},{"id":677,"category":"Storage Baskets"},{"id":678,"category":"Decorative Accessories"},{"id":680,"category":"Glasses"},{"id":681,"category":"Glasses"},{"id":692,"category":"Coffee Tables"},{"id":694,"category":"Area Rugs"},{"id":697,"category":"Coffee Tables"},{"id":698,"category":"Media Cabinets"},{"id":700,"category":"Pillows"},{"id":701,"category":"Pillows"},{"id":703,"category":"Decorative Accessories"},{"id":704,"category":"Decorative Accessories"},{"id":705,"category":"Dining Tables"},{"id":706,"category":"Lamps/Lighting"},{"id":707,"category":"Area Rugs"},{"id":709,"category":"Decorative Accessories"},{"id":710,"category":"Lamps/Lighting"},{"id":711,"category":"Decorative Accessories"},{"id":713,"category":"Lamps/Lighting"},{"id":715,"category":"Decorative Accessories"},{"id":716,"category":"Blankets & Throws"},{"id":717,"category":"Wall Art"},{"id":718,"category":"Wall Art"},{"id":719,"category":"Wall Art"},{"id":721,"category":"Floor Lamps"},{"id":722,"category":"Sofas"},{"id":723,"category":"Arm Chairs"},{"id":725,"category":"Sofas"},{"id":728,"category":"Dining Chair"},{"id":730,"category":"Sleeper Sofa"},{"id":731,"category":"Arm Chairs"},{"id":733,"category":"Side Table"},{"id":735,"category":"Lamps/Lighting"},{"id":737,"category":"Stools"},{"id":739,"category":"Wall Art"},{"id":740,"category":"Wall Art"},{"id":741,"category":"Wall Art"},{"id":742,"category":"Wall Art"},{"id":745,"category":"Chandeliers"},{"id":748,"category":"Decorative Accessories"},{"id":749,"category":"Console Table"},{"id":750,"category":"Wall Mirrors"},{"id":752,"category":"Candleholders"},{"id":753,"category":"TVs"},{"id":754,"category":"TVs"},{"id":755,"category":"TVs"},{"id":756,"category":"Stools"},{"id":757,"category":"Wall Art"},{"id":758,"category":"Wall Art"},{"id":759,"category":"Plants"},{"id":760,"category":"Decorative Accessories"},{"id":761,"category":"Benches"},{"id":763,"category":"Lamps/Lighting"},{"id":765,"category":"Plants"},{"id":766,"category":"Plants"},{"id":767,"category":"Plants"},{"id":771,"category":"Accent Chairs"},{"id":774,"category":"Decorative Accessories"},{"id":783,"category":"Decorative Accessories"},{"id":785,"category":"Decorative Accessories"},{"id":787,"category":"Decorative Accessories"},{"id":789,"category":"Decorative Accessories"},{"id":790,"category":"Plants"},{"id":792,"category":"Stools"},{"id":803,"category":"Vases"},{"id":804,"category":"Vases"},{"id":805,"category":"Vases"},{"id":806,"category":"Vases"},{"id":807,"category":"Decorative Accessories"},{"id":808,"category":"Decorative Accessories"},{"id":809,"category":"Glasses"},{"id":810,"category":"Candles"},{"id":811,"category":"Candles"},{"id":812,"category":"Candles"},{"id":813,"category":"Candles"},{"id":814,"category":"Plants"},{"id":815,"category":"Plants"},{"id":816,"category":"Plants"},{"id":817,"category":"Plants"},{"id":819,"category":"Dinnerware"},{"id":820,"category":"Decorative Accessories"},{"id":821,"category":"Vases"},{"id":822,"category":"Vases"},{"id":823,"category":"Candleholders"},{"id":824,"category":"Candleholders"},{"id":825,"category":"Decorative Accessories"},{"id":826,"category":"Decorative Accessories"},{"id":827,"category":"Vases"},{"id":828,"category":"Decorative Accessories"},{"id":832,"category":"Books"},{"id":833,"category":"Decorative Accessories"},{"id":834,"category":"Plants"},{"id":835,"category":"Plants"},{"id":836,"category":"Plants"},{"id":837,"category":"Plants"},{"id":838,"category":"Decorative Accessories"},{"id":839,"category":"Decorative Accessories"},{"id":840,"category":"Decorative Accessories"},{"id":841,"category":"Decorative Accessories"},{"id":842,"category":"Decorative Accessories"},{"id":843,"category":"Decorative Accessories"},{"id":844,"category":"Area Rugs"},{"id":845,"category":"Candleholders"},{"id":846,"category":"Accent Chairs"},{"id":847,"category":"Plants"},{"id":848,"category":"Candleholders"},{"id":849,"category":"Candleholders"},{"id":850,"category":"Decorative Accessories"},{"id":851,"category":"Decorative Accessories"},{"id":852,"category":"Decorative Accessories"},{"id":853,"category":"Decorative Accessories"},{"id":855,"category":"Decorative Accessories"},{"id":856,"category":"Decorative Accessories"},{"id":857,"category":"Decorative Accessories"},{"id":858,"category":"Decorative Accessories"},{"id":859,"category":"Decorative Accessories"},{"id":861,"category":"Decorative Accessories"},{"id":862,"category":"Decorative Accessories"},{"id":865,"category":"Coffee Tables"},{"id":910,"category":"Mirrors"},{"id":911,"category":"Computers"},{"id":926,"category":"Accent Chairs"},{"id":927,"category":"Dressers"},{"id":928,"category":"Side Table"},{"id":930,"category":"Benches"},{"id":931,"category":"Chandeliers"},{"id":932,"category":"Mirrors"},{"id":934,"category":"Dressers"},{"id":935,"category":"Table Lamps"},{"id":937,"category":"Vases"},{"id":938,"category":"Vases"},{"id":939,"category":"Pillows"},{"id":941,"category":"Pillows"},{"id":942,"category":"Wall Sconces"},{"id":943,"category":"Wallpaper"},{"id":945,"category":"Beds"},{"id":946,"category":"Area Rugs"},{"id":947,"category":"Wall Art"},{"id":948,"category":"Blankets & Throws"},{"id":949,"category":"Plants"},{"id":1338,"category":"Throw Pillows"},{"id":1339,"category":"Throw Pillows"},{"id":1340,"category":"Side Table"},{"id":1341,"category":"Table Lamps"},{"id":1342,"category":"Area Rugs"},{"id":1343,"category":"Floor Lamps"},{"id":1344,"category":"Desks"},{"id":1345,"category":"Table Lamps"},{"id":1346,"category":"Accent Chairs"},{"id":1347,"category":"Arm Chairs"},{"id":1349,"category":"Mirrors"},{"id":1350,"category":"Wall Art"},{"id":1352,"category":"Stools"},{"id":1353,"category":"Wall Art"},{"id":1354,"category":"Wall Art"},{"id":1355,"category":"Throw Pillows"},{"id":1356,"category":"Table Lamps"},{"id":1357,"category":"Beds"},{"id":1358,"category":"Area Rugs"},{"id":1359,"category":"Area Rugs"},{"id":1385,"category":"Sofas"},{"id":1386,"category":"Dressers"},{"id":1387,"category":"Nightstand"},{"id":1388,"category":"Coffee Tables"},{"id":1421,"category":"Dining Tables"},{"id":1422,"category":"TVs"}]}';
        let assetCategoriesObj = JSON.parse( assetCategoryInfo ).assets;

        let relationshipInfo = '{"Stools":{"parents":null},"Glasses":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Decorative Accessories":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Dressers":{"parents":null},"Chair":{"parents":null},"Lamps/Lighting":{"parents":null},"Throw Pillows":{"parents":["Sofas","Benches","Accent Chairs","Sleeper Sofa","Beds","Arm Chairs","Dining Chair"]},"Dining Tables":{"parents":null},"Pillows":{"parents":["Beds","Sleeper Sofa"]},"Coffee Tables":{"parents":null},"Sofas":{"parents":null},"Vases":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Benches":{"parents":null},"Mirrors":{"parents":null},"Chandeliers":{"parents":null},"Accent Chairs":{"parents":null},"Media Cabinets":{"parents":null},"Side Table":{"parents":null},"Area Rugs":{"parents":null},"Computers":{"parents":["Side Table","Desks","Console Table"]},"Plants":{"parents":null},"Wallpaper":{"parents":null},"Wall Art":{"parents":null},"TVs":{"parents":["Console Table","Media Cabinets"]},"Dinnerware":{"parents":["Dining Tables"]},"Floor Lamps":{"parents":null},"Table Lamps":{"parents":["Side Table","Nightstand","Coffee Tables"]},"Storage Baskets":{"parents":null},"Sleeper Sofa":{"parents":null},"Nightstand":{"parents":null},"Wall Mirrors":{"parents":null},"Window Panels":{"parents":null},"Wall Sconces":{"parents":null},"Bowls":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Pendant Lamps":{"parents":null},"Beds":{"parents":null},"Candleholders":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Desks":{"parents":null},"Arm Chairs":{"parents":null},"Blankets & Throws":{"parents":["Beds","Sleeper Sofa"]},"Books":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Candles":{"parents":["Dressers","Dining Tables","Coffee Tables","Media Cabinets","Side Table","Nightstand","Desks","Console Table"]},"Console Table":{"parents":null},"Curtain Rods":{"parents":null},"Dining Chair":{"parents":null}}';
        this.relationshipsList = JSON.parse( relationshipInfo );

        this.debugEngine.debugLog("category list",this.relationshipsList);
        for ( let asset of assetCategoriesObj ) {

            this.itemCategoryList[ asset.id.toString() ] = asset.category;

        }
    }

    /**
     * Set up managers before loading space
     */
    setupPreSpaceManagers() {
        this.debugEngine = this.managersDict[Constants.Manager.DebugEngine];
        this.assetManager = this.buildAssetManager();
    }

    /**
     * Set up asset loading manager to load collection and assets
     */
    buildAssetManager() {
        const manager = new AssetLoadingManager(this.baseDirURL, this.managersDict);
        this.managersDict[Constants.Manager.AssetLoadingManager] = manager;
        manager.addEventListener( 'loadingProgress', this.onLoadingProgress );
        return manager;
    }

    /**
     * Set up auto placement manager to place assets in the scene
     */
    buildAutoPlacementManager() {
        const manager = new AutoPlacementManager( this.scene, this.sceneAssets, this.sceneToLoadAssets, this.itemCategoryList, this.itemsPlacementList, this.itemMaterialTypes, this.relationshipsList, this.lostAndFoundAreaItems, this.managersDict);
        this.managersDict[Constants.Manager.AutoPlacementManager] = manager;
        return manager;
    }

    /**
     * Load the space glb in the scene
     * @param {Function} onLoadAction - Call back function to be executed after loading the space
     */
    loadSpace (onLoadAction, spaceObj = null) {

        let action = onLoadAction;
        let scope = this;
        let spaceURL = this.spaceObj.url;
        let spaceName = this.spaceObj.name;

        if (spaceObj != null) {
            spaceURL = spaceObj.url;
            spaceName = `${spaceObj.name}`;
        }

        if (spaceName == null) {
            spaceName   	= spaceURL.split('/');
            spaceName 		= spaceName[ spaceName.length - 1 ];
            spaceName 		= spaceName.split('.');
            spaceName 		= spaceName[0];
        }
		
		let sunLoadInfo = null;

		if ( this.sceneToLoadInfo != null ) {
			sunLoadInfo = this.sceneToLoadInfo.sun;
		}

		this.assetManager.loadSpaceAsset( spaceURL, ( sceneObj ) => {

			if ( sceneObj != null ) {
                scope.space = new Space( spaceName, sceneObj, sunLoadInfo );
                scope.managersDict[Constants.Manager.SpaceManager] = scope.space;
                action();
			}
			else {
                this.debugEngine.debugLog( "Failed to load space" );
                if (this.setLoadingProgressMessage != null) {
                    this.setLoadingProgressMessage( "Loading Failed!" );
                }
			}

        } );

    }

    /**
    * Set the assets after space swap
    * @param {Function} onPopulatedAction - The call back function to be executed after
    */
    setAssetsAfterSpaceSwap(onPopulatedAction) {
        var scope = this;
        this.autoPlacementManager = scope.buildAutoPlacementManager();
        this.raycastManager = scope.managersDict[Constants.Manager.RaycastManager];
        var action = onPopulatedAction;

        scope.autoPlacementManager.onStoredAssetsPlaced();
        scope.autoPlacementManager.setMiscAssetsInScene();
        scope.raycastManager.setAssetsList(this.sceneAssets);
        scope.raycastManager.buildFocusTargetList();
        action();
    } 

    /**
     * Load the assets collections in the scene and set them
     * @param {Function} onPopulatedAction - The call back function to be executed after loading assets
     */
    loadAssets( onPopulatedAction ) {

        this.autoPlacementManager = this.buildAutoPlacementManager();
        this.raycastManager = this.managersDict[Constants.Manager.RaycastManager];
        var action = onPopulatedAction;

        if(this.sceneType === 'space_test') {
            if(Object.keys(this.space.areas).length > 0) {
                if('Default' in this.spaceItemsList) {
                    // If array against default key is of length zero then use hard coded assets
                    // Else use the assets passed against default key
                    if(this.spaceItemsList['Default'].length == 0) {
                        this.spaceItemsList[Object.keys(this.space.areas)[0]] = ["1591", "673", "758", "753", "1600", "650", "640", "643", "846", "1358", "813", "850", "3337", "3765"];
                    }
                    else {
                        this.spaceItemsList[Object.keys(this.space.areas)[0]] = this.spaceItemsList['Default'];
                    }
                }
                else {
                    this.spaceItemsList[Object.keys(this.space.areas)[0]] = ["1596", "2411","643","742", "3617"];
                }
            }
        }

        var collections = this.spaceItemsList;

        if (Object.keys(this.space.areas)?.length == 1 && this.spaceItemsList['Outdoor'] == undefined && !collections[Object.keys(this.space.areas)[0]]?.length ) {

            collections[Object.keys(this.space.areas)[0]] = this.spaceItemsList['Default'];
        }

        this.debugEngine.debugLog("collections items", collections);

		// Populate via load info
		if ( this.sceneToLoadInfo != null ) {
            this.setupAssetsWithLoadInfo(collections, action);
        }

		// Populate via AutoPlacement - on new scene creation or test scene placement
		else {
            this.setupAssetWithAutoPlacement(collections, action);
		}

    }

    /**
    * load assets list in scene with placement 
    * @param {Array} assets - The collection of assets in to be added
    * @param {Function} action - The callback function to be called after loading collection
    */
    loadDeletedAssets(assets, action) {
        let collectionBundle = [];
        for (let asset of assets) {
            if (!collectionBundle.includes(asset.asset_name)) {
            collectionBundle.push(asset.asset_name);
            }
        }
        this.assetManager.loadCollection(collectionBundle, () => {
            this.autoPlacementManager.placeDeletedAssets(assets, action);
        } );
    }    

    /**
     * Setup Assets in a saved scene
     * @param {Array} collections - The collection of assets in the scene
     * @param {Function} action - The callback function to be called after loading collection
     */
    setupAssetsWithLoadInfo( collections, action) {
        this.debugEngine.setIntervalStartToCurrentTime();
        var scope = this;
        let prePlacedItems = [];
        this.sceneToLoadInfo.assets.forEach( ( asset, index ) => {
            prePlacedItems.push(asset.asset_name.toString());
        } );

        this.assetManager.loadCollection(prePlacedItems, () => {

            scope.autoPlacementManager.onStoredAssetsPlaced();
            scope.debugEngine.logIntervalTime('saved-asset loading done');
            if(scope.editModeOn == true) {
                let collectionBundle = [];
                for(let key in collections) {
                    for (let item of collections[key]){
                        collectionBundle.push(item.toString());
                    }
                }

                this.debugEngine.debugLog(collectionBundle);
                this.debugEngine.debugLog(prePlacedItems);

                // Find newly added items of collection
                let diff = collectionBundle.filter(x => !prePlacedItems.includes(x) );

                scope.assetManager.loadCollection(diff, () => {
                    // Find the collection items which were newly added.
                    let diffCollections = {};
                    for (let key in this.space.areas) {
                        diffCollections[key] = [];
                        let areaDiffCollection = [];    // Diff collection for this unit

                        for(let index in collections[key]) {
                            let itemName = collections[key][index];

                            // Only add if this item is present in diff array
                            let itemIndexInDiffArr = diff.indexOf(itemName);
                            if (itemIndexInDiffArr != -1) {
                                areaDiffCollection.push(itemName);
                            }
                        }

                        diffCollections[key] = areaDiffCollection;
                    }

                    // auto place newly added items in the collection
                    this.debugEngine.debugLog("Diff collection: ", diffCollections);
                    scope.autoPlacementManager.autoPlaceAssets(diffCollections, action, this.sceneAssets);
                });
            }
            else {
                scope.raycastManager.setAssetsList( this.sceneAssets );
                scope.raycastManager.buildFocusTargetList( );
                action();
            }
        }, (index) => {scope.autoPlacementManager.placeStoredAsset(index)} );
    }

    /**
    * Update placement type list
    * @param {Object} itemsPlacementList - The placement types of objects to be auto placed
    */
    updateItemsPlacementList(itemsPlacementList) {
        this.autoPlacementManager.updateItemsPlacementList(itemsPlacementList)
        this.itemsPlacementList = Object.assign(itemsPlacementList, this.itemsPlacementList)
    }

    updateItemsPlacementofObject(objectName, placementType) {
        this.itemsPlacementList[objectName] = placementType;
        this.autoPlacementManager.updateItemsPlacementofObject(objectName, placementType)
    }

    /**
    * Update category list
    * @param {Object} itemsCategoryList - The placement types of objects to be auto placed
    */
    updateItemsCategoryList(itemsCategoryList) {
        this.autoPlacementManager.updateItemsCategoryList(itemsCategoryList)
        this.itemCategoryList = Object.assign(itemsCategoryList, this.itemCategoryList)
    }

    /**
    * Update material types list
    * @param {Object} itemsMaterialTypesList - The placement types of objects to be auto placed
    */
    updateItemsMaterialTypesList(itemsMaterialTypesList) {
        this.autoPlacementManager.updateItemsMaterialTypesList(itemsMaterialTypesList)
        this.itemMaterialTypes = Object.assign(itemsMaterialTypesList, this.itemMaterialTypes)
    }

    /**
     * Auto place collection assets
     * @param {Array} collections - The collection of assets in the scene
     * @param {Function} action - The callback function to be called after loading collection
     */
    setupAssetWithAutoPlacement(collections, action, setPrePlacedSceneAssets = false) {
        let collectionBundle = [];
        for(let key in collections) {
            collectionBundle = collectionBundle.concat(collections[key]);
        }

        let prePlacedSceneAssets = null;
        if (setPrePlacedSceneAssets) {
            prePlacedSceneAssets = this.sceneAssets;
        }

        this.assetManager.loadCollection(collectionBundle, () => {
            this.autoPlacementManager.autoPlaceAssets(collections, action, prePlacedSceneAssets);
        } );
    }

    loadSpaceConfiguration(onConfigurationLoaded) {
        this.spaceConfigurator = this.managersDict[Constants.Manager.SpaceConfigurator];
        if (this.spaceConfigurationInfo) {
            for (const configInfo of this.spaceConfigurationInfo) {
                // restore saved custom configuration ( if any ) on the component.
                const spaceObjName = configInfo.name;
                if (configInfo) {
                    const materialInfo = configInfo;
                    const spaceObj = this.space.scene.getObjectByName(spaceObjName)
                    if (spaceObj) {
                        if (materialInfo.type == Constants.SpaceConfigurationType.COLOR) {
                            this.spaceConfigurator.applyColorToSpaceComponent(spaceObj, materialInfo.hexCode, materialInfo.base_material_asset != null)
                            this.spaceConfigurator.addConfigurationInfo(configInfo)
                            if (spaceObj.name.toLowerCase().includes(Constants.SpaceStructureType.CEILING.toLowerCase())) {
                                onConfigurationLoaded(spaceObj)
                            }
                        }
                        else {
                            let textureBaseURL = null;
                            if (materialInfo.type == Constants.SpaceConfigurationType.TEXTURE) {
                                textureBaseURL = CONSTANTS.getBaseURL(configInfo.platform) + CONSTANTS.SPACE_MATERIAL_FILE_URI;
                            }
                            else {
                                textureBaseURL = CONSTANTS.getBaseURL(configInfo.platform) + CONSTANTS.MATERIAL_FILE_URI;
                            }
                            
                            const texture = textureBaseURL + configInfo.id + "/" + materialInfo.base_map;
                            if (texture) {
                                this.assetManager.loadTexture(texture, (textureRequest, textureData)=> {
                                    this.spaceConfigurator.applyMaterialToSpaceComponent(spaceObj, textureData,  materialInfo.horizontal_repeat, 
                                        materialInfo.vertical_repeat, materialInfo.roughness, materialInfo.horizontal_offset,
                                        materialInfo.vertical_offset, materialInfo.rotation, ()=> {
                                            this.spaceConfigurator.addConfigurationInfo(configInfo);
                                            if (spaceObj.name.toLowerCase().includes(Constants.SpaceStructureType.CEILING.toLowerCase())) {
                                                onConfigurationLoaded(spaceObj)
                                            }
                                        }) 
                                })
                            }
                        }
                    }
                }
            }
        }
    }
    /**
     * Getter to return scene assets
     */
    getSceneAssets() {
        return this.sceneAssets;
    }

    /**
     * Getter to return item category list
     */
    getItemCategoryList() {
        return this.itemCategoryList;
    }

    /**
     * Callback function to update loading progress for space and asset glbs
     * @param {Event} event - The loading event that is in progress
     */
    onLoadingProgress = ( event ) => {

        switch( event.assetType ) {

            case "space":
            // UPDATE UI HERE

            if (this.setLoadingProgressMessage != null) {
                this.setLoadingProgressMessage( "LOADING SPACE : " + event.value + "%" );
            }
            break;

            case "collection":
            // UPDATE UI HERE
            this.debugEngine.debugLog( "LOADING COLLECTION : " + event.assetsLoaded + " of " + event.totalAssets + " loaded" );
            if (this.setLoadingProgressMessage != null) {
                if(event.assetsLoaded >= event.totalAssets - 1) {
                    this.debugEngine.debugLog( "Placing the products in your space." );
                    this.setLoadingProgressMessage( "Placing the products in your space." );
                }
                // Only show loading progress if progressing forward
                else if (event.assetsLoaded > 0 && event.totalAssets > 0 && 
                         (event.assetsLoaded > this.previousAssetsLoaded || event.totalAssets !== this.previousTotalAssets)) {
                    this.debugEngine.debugLog("LOADING COLLECTION : " + event.assetsLoaded + " of " + event.totalAssets + " loaded");
                    this.setLoadingProgressMessage( "LOADING COLLECTION : " + event.assetsLoaded + " of " + event.totalAssets + " loaded" );
                    
                    // Update previous state
                    this.previousAssetsLoaded = event.assetsLoaded;
                    this.previousTotalAssets = event.totalAssets;
                }
            }
            break;

            case "sceneAsset":
            // This is for debug purpose only
            this.debugEngine.debugLog( "LOADING ASSET ( " + event.assetName + " ) : " + event.value + "%" );
            break;

            case "spaceFailed":
            if (this.setLoadingProgressMessage != null) {
                this.setLoadingProgressMessage( "Loading Failed!" );
            }
            break;
        }
    }
    
    autoPlaceGroupedAssets (groupedAssets, isBabylonExported) {
        var scope = this;
        scope.autoPlacementManager.autoPlaceGroup(groupedAssets, isBabylonExported);
    }

    autoPlaceWallAssets (wallAssets) {
        var scope = this;
        scope.autoPlacementManager.autoPlaceWallAssets(wallAssets);
    }

    setSpaceConfigurationInfo (spaceConfigurationInfo) {
        this.spaceConfigurationInfo = spaceConfigurationInfo;
    }
  }